import moment from "moment";

const formatDate = (date) => {
    if (!date || !moment(date).isValid()) return '-';
    return moment(date).format('DD/MM/YYYY');
};

export const adaptCierre = (item) => {
    return {
        factura_Codigo: item.factura_Codigo,
        organizacion_ventas: item.organizacion_ventas,
        fechaDesde: formatDate(item.fechaDesde),
        fechaHasta: formatDate(item.fechaHasta),
        fecha: formatDate(item.fecha),
        zona_ventas_Codigo: item.zona_ventas_Codigo,
        zona_ventas_Nombre: item.zona_ventas_Nombre,
        oficina_ventas: item.oficina_ventas,
        delegacion: item.delegacion,
        creado_por: item.creado_por,
        factura_Referencia_Anul: item.factura_Referencia_Anul,
        factura_Clase: item.factura_Clase,
        solicitante_Codigo: item.solicitante_Codigo,
        solicitante_Nombre: item.solicitante_Nombre,
        solicitante_Ramo: item.solicitante_Ramo,
        solicitante_Region: item.solicitante_Region,
        factura_Cantidad: item.factura_Cantidad,
        material_Codigo: item.material_Codigo,
        material_Descripcion: item.material_Descripcion,
        remito_Referencia: item.remito_Referencia,
        remito_Clase: item.remito_Clase,
        centro: item.centro,
        tipo_Pedido: item.tipo_Pedido,
        material_Tipo: item.material_Tipo,
        material_Sub_Tipo: item.material_Sub_Tipo,
        seReporta: item.seReporta,
        material_Cantidad: item.material_Cantidad,
        importe_unitario: item.importe_unitario,
        material_Total_Neto: item.material_Total_Neto,
        factura_IVA: item.factura_IVA,
        factura_Referencia: item.factura_Referencia,
        grupo_Imp_Cliente: item.grupo_Imp_Cliente,
        grupo_Cliente: item.grupo_Cliente,
        cod_Cliente_Destinatario: item.cod_Cliente_Destinatario,
        cliente_Destinatario: item.cliente_Destinatario,
        pacienteActivo: item.pacienteActivo,
        documento_Ventas: item.documento_Ventas,
        ivaPaciente: item.ivaPaciente,
        descIvaPaciente: item.descIvaPaciente,
    };
};

export const adaptVentasMaestro = (item) => {
    return {
        factura_Codigo: item.factura_Codigo,
        organizacion_ventas: item.organizacion_ventas,
        fecha_Factura: formatDate(item.fecha_Factura),
        fecha_Real: formatDate(item.fecha_Real),
        fecha: formatDate(item.fecha),
        usuario: item.usuario,
        zona_ventas_Codigo: item.zona_ventas_Codigo,
        zona_ventas_Nombre: item.zona_ventas_Nombre,
        creado_por: item.creado_por,
        factura_Referencia_Anul: item.factura_Referencia_Anul,
        factura_Clase: item.factura_Clase,
        solicitante_Codigo: item.solicitante_Codigo,
        solicitante_Nombre: item.solicitante_Nombre,
        solicitante_Ramo: item.solicitante_Ramo,
        solicitante_Region: item.solicitante_Region,
        factura_Cantidad: item.factura_Cantidad,
        material_Codigo: item.material_Codigo,
        material_Descripcion: item.material_Descripcion,
        material_Lote: item.material_Lote,
        oficina_ventas: item.oficina_ventas,
        remito_Referencia: item.remito_Referencia,
        remito_Clase: item.remito_Clase,
        aPM_Codigo: item.aPM_Codigo,
        aPM_Nombre: item.aPM_Nombre,
        jEFE_Codigo: item.jEFE_Codigo,
        jEFE_Nombre: item.jEFE_Nombre,
        bUM_Codigo: item.bUM_Codigo,
        bUM_Nombre: item.bUM_Nombre,
        lMTP: item.lMTP,
        lLTP: item.lLTP,
        zLTP: item.zLTP,
        zMTP: item.zMTP,
        centro: item.centro,
        tipo_Pedido: item.tipo_Pedido,
        material_Tipo: item.material_Tipo,
        material_Sub_Tipo: item.material_Sub_Tipo,
        material_Cantidad: item.material_Cantidad,
        material_Total_Neto: item.material_Total_Neto,
        factura_Referencia: item.factura_Referencia,
        factura_IVA: item.factura_IVA,
        factura_IIBB_BA: item.factura_IIBB_BA,
        factura_IIBB_CABA: item.factura_IIBB_CABA,
        factura_IIBBA_CHA: item.factura_IIBBA_CHA,
        factura_Total_Neto: item.factura_Total_Neto,
        grupo_Imp_Cliente: item.grupo_Imp_Cliente,
        grupo_Cliente: item.grupo_Cliente,
        tipo_Cambio: item.tipo_Cambio,
        cod_Cliente_Destinatario: item.cod_Cliente_Destinatario,
        cliente_Destinatario: item.cliente_Destinatario,
        documento_Ventas: item.documento_Ventas,
    };
};

export const adaptCierreAgrupado = (item) => {
    return {
        materialTipo: item.materialTipo,
        cantidad: item.cantidad,
        total: item.total,
    };
};

export const adaptPendienteMes = (item) => {
    return adaptVentasMaestro(item);
};

export const adaptDiferencias = (item) => {
    return {
        idConexion: item.idConexion,
        idMinuta: item.idMinuta,
        cod_Paciente: item.cod_Paciente,
        paciente: item.paciente,
        idEvaluacion: item.idEvaluacion,
        precioDiario: item.precioDiario,
        idCliente: item.idCliente,
        cliente: item.cliente,
        moduloTipo: item.moduloTipo,
        delegacion: item.delegacion,
        usuario: item.usuario,
        fechaConexion: formatDate(item.fechaConexion),
        fechaAlta: formatDate(item.fechaAlta),
        accion: item.accion,
    };
};

export const adaptDiferenciasAgrupadas = (item) => {
    return {
        idConexion: item.idConexion,
        idMinuta: item.idMinuta,
        cod_Paciente: item.cod_Paciente,
        paciente: item.paciente,
        idEvaluacion: item.idEvaluacion,
        precioDiario: item.precioDiario,
        idCliente: item.idCliente,
        cliente: item.cliente,
        moduloTipo: item.moduloTipo,
        delegacion: item.delegacion,
        fechaInicio: formatDate(item.fechaInicio),
        fechaFin: formatDate(item.fechaFin),
        accion: item.accion,
    };
};

const headersCierre = [
    'Cod. Factura', 'Ventas', 'Fecha Desde', 'Fecha Hasta', 'Fecha',
    'Cod. Zona de ventas', 'Nombre de Zona de ventas', 'Oficina de Ventas', 'Delegacion',
    'Creado Por ', 'Factura Ref. Anul.', 'Clase de factura', 'Cod. Solicitante',
    'Nombre Solicitante', 'Ramo Solicitante', 'Region Solicitante', 'Cantidad Factura',
    'Cod. Material', 'Descripcion Material', 'Referencia Remito', 'Clase Remito',
    'Centro', 'Tipo Pedido', 'Tipo Material', 'Subtipo Material', 'SeReporta', 'Cantidad Material',
    'Importe Unitario', 'Total Neto Material', 'IVA Factura', 'Referencia Factura',
    'Grupo Imp. Cliente', 'Grupo Cliente', 'Cod. Cliente Destinatario',
    'Cliente Destinatario', 'Paciente Activo', 'Documento Ventas', 'IVA Paciente', 'Desc. IVA Paciente'
];

const headersVentasMaestro = [
    'Cod. Factura', 'Org. Ventas', 'F. Factura', 'F. Real', 'Fecha', 'Usuario', 'Cod. Zona',
    'Zona', 'Creado por', 'Ref. Anulada', 'Clase Fact.', 'Cod. Solicit.', 'Solicitante',
    'Ramo', 'Región', 'Cant. Fact.', 'Cod. Mat.', 'Desc. Mat.', 'Lote', 'Of. Ventas',
    'Ref. Remito', 'Clase Remito', 'Cod. APM', 'APM', 'Cod. Jefe', 'Jefe', 'Cod. BUM', 'BUM', 'LMTP', 'LLTP',
    'ZLTP', 'ZMTP', 'Centro', 'Tipo Ped.', 'Tipo Mat.', 'Subtipo Mat.', 'Cant. Mat.',
    'Total Neto Mat.', 'Ref. Factura', 'IVA', 'IIBB BA', 'IIBB CABA', 'IIBB CHA', 'Total Neto Fact.',
    'Grupo Imp.', 'Grupo Cliente', 'T. Cambio', 'Cod. Cliente', 'Cliente', 'Doc. Ventas',
];

const headersCierreAgrupado = [
    "Tipo material", "Cantidad", "Total"
];

const headersPendienteMes = headersCierre;

const headersDiferencias = [
    'ID Conex.', 'ID Minuta', 'Cod. Pac.', 'Paciente', 'ID Eval.', 'Precio Día',
    'ID Cliente', 'Cliente', 'Módulo', 'Delegación', 'Usuario', 'F. Conex.', 'F. Alta', 'Acción'
];

const headersDiferenciasAgrupadas = [
    'ID Conex.', 'ID Minuta', 'Cod. Pac.', 'Paciente', 'ID Eval.', 'Precio Día',
    'ID Cliente', 'Cliente', 'Módulo', 'Delegación', 'F. Inicio', 'F. Fin', 'Acción'
];

export const getHeadersByType = (type) => {
    switch (type) {
        case 1: return headersCierre;
        case 2: return headersVentasMaestro;
        case 3: return headersCierreAgrupado;
        case 4: return headersPendienteMes;
        case 5: return headersDiferencias;
        case 6: return headersDiferenciasAgrupadas;
        default: return [];
    }
};

export const headersExcelConexiones = [
    'Región', 'Delegación', 'Id Evaluación', 'Tipo Módulo',
    'Módulo', 'Precio Diario', 'HC', 'Paciente', 'Cod. Cliente', 'Cliente',
];